<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsmj1">&nbsp; &nbsp;
        <img :src="images.zsmj2" style="line-height:1.5;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Inject Mould</span>
        </b>
        <b>
          <span style="font-size:16.0pt;font-family:Arial;"></span>
        </b>
      </p>
      <p>
        <span style="font-size:18px;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >Injection products involve electronics, machinery, cosmetics, food and other industries. Our company provides one-stop service for design, processing and warranty.</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
        <img :src="images.zsmj3" style="line-height:1.5;">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsmj1: require("../../../assets/img/common/zsmj1.jpg"),
        zsmj2: require("../../../assets/img/common/zsmj2.jpg"),
        zsmj3: require("../../../assets/img/common/zsmj3.jpg")
      }
    };
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/zsmj.vue